import { useMemo } from 'react';
import { useGetCreatorCommunitiesQuery } from 'generated/graphql';
import { resolveInfluencerId } from '../lib/resolveInfluencerId';

export type CreatorIdentity = {
  name: string;
  avatarUrl: string | null;
};

export const useCommunityCreatorIdentity = (
  influencerId?: string | number,
): CreatorIdentity | null => {
  const creatorId = resolveInfluencerId(influencerId);

  const { data } = useGetCreatorCommunitiesQuery({
    variables: { id: creatorId ?? 0 },
    skip: creatorId === null,
    fetchPolicy: 'cache-and-network',
  });

  const creator = data?.creator;

  return useMemo<CreatorIdentity | null>(() => {
    if (!creator) return null;
    const { mediaAvatar } = creator;
    const avatarUrl = mediaAvatar
      ? `${mediaAvatar.cdn01 ?? ''}${mediaAvatar.image ?? ''}`
      : null;
    return { name: creator.name ?? '', avatarUrl };
  }, [creator]);
};
